module.exports = __webpack_public_path__ + "media/images/pages/solutions/automation-35d0537ae762e9d24e22e6ad6ecb903b.svg";